import { Box, Image, Stack, Text, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { FiArrowLeftCircle } from "react-icons/fi";
import useSmallScreen from "../../components/useSmallScreen";
import { photoBaseURL } from "../../service/api";
import { trunc } from "../../utils";
import ChatArea from "./ChatArea";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { getGroupChatMessages, sendGroupChatMessage } from "./service";
import useGroupChat from "./useGroupChat";
import { BiToggleLeft } from "react-icons/bi";

function RightSection({
  currentGroupChat,
  setReceiverCurrentChat,
  receiverCurrentChat,
  onToggle,
  setIsUserChatDetailsOpen,
  isUserChatDetailsOpen,
  setIncomingLastMessage,
  /////////////////////
  setShowCall,
  chats,
  userId,
  accountType,
  user,
  selectedChat,
  setCurrentMobileScreenState,
  ...props
}) {
  const ChatBorderBg = useColorModeValue("#DBE5ED", "#081b2e");
  const chatContainer2Bg = useColorModeValue("#F9FAFC", "#081b2e");
  const section2Bg = useColorModeValue("#F4F5F8", "#030c1b");
  const nameColor = useColorModeValue("#4B5155", "#fff");
  const [smallScreen] = useSmallScreen();
  const [isSocketConnected, setIsSocketConnected] = useState(true);
  const [imgPreview, setImgPreview] = useState(undefined);
  const [isServerImageLoaded, setIsServerImageLoaded] = useState(false);
  const [progressBar, setProgressBar] = useState(undefined);

  const authUser = user;

  const { groupMessages, sendMessage, sendFile, } = useGroupChat(
    currentGroupChat,
    authUser,
    setIsSocketConnected,
    isSocketConnected,
    setIncomingLastMessage,
    setProgressBar,
  );
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const token = sessionStorage.getItem("#f8WEB#");
  // Define headers with the bearer token
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  const handleSendMsg = async (msg) => {
    await sendMessage(msg);
    setReceiverCurrentChat(currentGroupChat);
  };

  const handleSendFile = async (fileData, e) => {
    await sendFile(fileData, e);
  };

  const toggleUserDetails = () => {
    setIsUserChatDetailsOpen(!isUserChatDetailsOpen)
  }

  return (
    <Stack
      flex={["3", "3", "3", "6"]}
      border={`1px solid ${ChatBorderBg}`}
      bg={chatContainer2Bg}
      borderRadius={"15px"}
      {...props}
    >
      <Stack
        direction={"row"}
        alignItems="center"
        bg={section2Bg}
        borderTopLeftRadius={"15px"}
        borderTopRightRadius={"15px"}
        p="5px"
        justifyContent={"space-between"}
      >
        <Stack w={"100%"} ml={"95%"}><BiToggleLeft onClick={toggleUserDetails} fontSize={"2em"} cursor={"pointer"}/></Stack>

        {smallScreen && (
          <FiArrowLeftCircle
            fontSize={"2em"}
            cursor={"pointer"}
            onClick={() => setCurrentMobileScreenState(0)}
          />
        )}
        {chats?.group_chat?.members && (
          <Stack direction={"row"} alignItems="center">
            <Image
              w="30px"
              h="30px"
              borderRadius={"50%"}
              border={"2px solid #fff"}
              objectFit="cover"
              src={`${photoBaseURL}${chats?.group_chat?.photo}`}
            />

            <Tooltip
              label={chats?.group_chat?.members
                ?.map((member) => member?.user?.username)
                ?.filter((data) => data)
                ?.join(", ")}
            >
              <small color={nameColor}>
                {trunc(
                  chats?.group_chat?.members
                    ?.map((member) => member?.user?.username)
                    ?.filter((data) => data)
                    ?.join(", "),
                  80
                )}
              </small>
            </Tooltip>
          </Stack>
        )}
      </Stack>
      
      <Stack p={["3px", "20px"]}>
        
        <ChatArea
          chats={chats}
          userId={userId}
          accountType={accountType}
          selectedChat={selectedChat}
          user={user}
          //////////////////////
          groupMessages={groupMessages}
          currentGroupChat={currentGroupChat}
          receiverCurrentChat={receiverCurrentChat}
          handleSendMsg={handleSendMsg}
          handleSendFile={handleSendFile}
          setImgPreview={setImgPreview}
          setIsServerImageLoaded={setIsServerImageLoaded}
          isServerImageLoaded={isServerImageLoaded}
          setProgressBar={setProgressBar}
          progressBar={progressBar}
        />
      </Stack>
    </Stack>
  );
}

export default RightSection;
